import {ethers} from "ethers";
import {
    bsc,
    PANCAKE_FACTORY_V2, PANCAKE_FACTORY_V2_ABI,
    PANCAKE_ROUTER_V2,
    PANCAKE_ROUTER_V2_ABI,
    provider,
    TOKEN_ABI, uniswap, UNISWAP_FACTORY_V2, UNISWAP_FACTORYV2_ABI,
    UNISWAP_ROUTER_V2, UNISWAP_ROUTERV2_ABI,
} from "../const";

export const erc = (account, coinAddress) => new ethers.Contract(
    coinAddress,
    [{
        "constant": true,
        "inputs": [{"name": "_owner", "type": "address"}],
        "name": "balanceOf",
        "outputs": [{"name": "balance", "type": "uint256"}],
        "payable": false,
        "type": "function"
    }],
    account
);

export const binanceTransactionRouter = (account) => new ethers.Contract(
    PANCAKE_ROUTER_V2,
    [
        'function swapExactETHForTokens(uint amountOutMin, address[] calldata path, address to, uint deadline) external payable returns (uint[] memory amounts)',
        'function swapExactTokensForETHSupportingFeeOnTransferTokens(uint amountIn, uint amountOutMin, address[] calldata path, address to, uint deadline) external',
        'function swapExactTokensForTokensSupportingFeeOnTransferTokens(uint amountIn, uint amountOutMin, address[] calldata path, address to, uint deadline) external',
        'function getAmountsOut(uint amountIn, address[] calldata path) external view returns (uint[] memory amounts)',
        'function swapExactETHForTokensSupportingFeeOnTransferTokens(uint amountOutMin, address[] calldata path, address to, uint deadline) external payable'
    ],
    account
);

export const uniswapTransactionRouter = (account) => new ethers.Contract(
    UNISWAP_ROUTER_V2,
    [
            'function swapExactETHForTokens(uint amountOutMin, address[] calldata path, address to, uint deadline) external payable returns (uint[] memory amounts)',
            'function swapExactTokensForETHSupportingFeeOnTransferTokens(uint amountIn, uint amountOutMin, address[] calldata path, address to, uint deadline) external',
            'function getAmountsOut(uint amountIn, address[] calldata path) external view returns (uint[] memory amounts)',
            'function swapExactETHForTokensSupportingFeeOnTransferTokens(uint amountOutMin, address[] calldata path, address to, uint deadline) external payable'
    ],
    account
);

export const getTokenContract = (tokenAddress, account) => new ethers.Contract(
    tokenAddress,
    TOKEN_ABI,
    account
)

export const pancakeRouterTokenInfo = new ethers.Contract(PANCAKE_ROUTER_V2, PANCAKE_ROUTER_V2_ABI, provider(bsc));
export const pancakeFactoryTokenInfo = new ethers.Contract(PANCAKE_FACTORY_V2, PANCAKE_FACTORY_V2_ABI, provider(bsc));
export const uniswapRouterTokenInfo = new ethers.Contract(UNISWAP_ROUTER_V2, UNISWAP_ROUTERV2_ABI, provider(uniswap));
export const uniswapFactoryTokenInfo = new ethers.Contract(UNISWAP_FACTORY_V2, UNISWAP_FACTORYV2_ABI, provider(uniswap));